<template>
  <div>
    <div class="card softblue">
      <div class="card-body">
        <div class="media">
          <img :src="userInfo.picture_path ? userInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <span class="badge rose">학생</span>
            <h5>{{userInfo.name}}</h5>
            <span>{{userInfo.school_name}} {{userInfo.id}}</span>
          </div>
        </div>
      </div>
    </div>

    <h3 class="title">응시한 시험 <span class="number strong mint">{{tableData.length}}</span></h3>

      <template v-if="tableData.length > 0">
        <!-- <div class="box-card card-exam" v-for="(exam, idx) in tableData" :key="idx" @click="goExamResult(exam.exam_seq, exam.class_seq, 'SR010201')"> -->
        <div class="box-card card-exam" v-for="(exam, idx) in tableData" :key="idx">
          <div class="d-flex">
            <div class="p-2">
              <!-- <img src="/static/img/test.png" class="icon" /> -->
              <img src="/static/img/test.png" />
            </div>
            <div class="p-2 user_exam_title">
              <h2>{{`${exam.class_name} / ${exam.title}`}}</h2>
            </div>
            <div class="p-2 ml-auto" style="padding-top:18px !important">
              <button type="primary" class="btn circle mint" @click="goExamResult(exam.exam_seq, exam.class_seq, 'SR010201')"><i class="fas fa-angle-right"></i></button>
              <!-- <button type="primary" class="btn circle mint" @click="goExamResult(exam.exam_seq, exam.class_seq, 'SR010203')"><i class="fas fa-angle-right"></i></button> -->
            </div>
          </div>
        </div>
      </template>
      <template v-else>
         <div class="box-card card-exam-disable text-center">
            응시한 시험 이력이 없습니다.
        </div>
      </template>
    </div>

</template>

<script>

import common from '@/modules/common'

export default {
  name: 'S010201',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      userInfo: {
        picture_path: '',
        name: '',
        id: '',
        school_name: ''
      }
    }
  },
  created () {
    this.loadUserInfo()
    this.retreiveExam()
  },
  methods: {
    loadUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
        })
    },
    retreiveExam () {
      const param = {}
      common.axios.post('/exam/list/user/history', param)
        .then(response => {
          this.tableData = response.data
        })
    },
    goExamResult (examSeq, classSeq, pageName) {
      const param = {
        exam_seq: examSeq,
        class_seq: classSeq,
        class_user_seq: this.$store.getters.user_seq
      }
      this.$router.push({name: pageName, params: param})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/S010201.vue